import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateTeacherSubjectForm from "../../forms/CreateOrUpdateTeacherSubjectForm";

interface CreateTeacherSubjectModalProps {
  open: boolean;
  onClose: () => void;
  loading: boolean;
  error: string | null;
}

const CreateTeacherSubjectModal: React.FC<CreateTeacherSubjectModalProps> = ({
  open,
  onClose,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title="Assign Subject to Teacher"
    width="sm"
    loading={loading}
  >
    <CreateOrUpdateTeacherSubjectForm loading={loading} error={error} />
  </AppModal>
);

export default CreateTeacherSubjectModal;
